/**
 * Pure helper functions that compute which source-control fields
 * (`webSearchEnabled`, `appFilters`, `sourceMode`) should be included in the `onSubmit`
 * payload when the user sends a message.
 */
import type { RovoApp } from '../../controllers/chat-mode-store/types';

import {
	areRovoControlsSuppressed,
	type RovoControlsSuppressedParams,
} from './areRovoControlsSuppressed';

export type AppFiltersForSubmitParams = RovoControlsSuppressedParams & {
	appFilters?: RovoApp[];
};

/**
 * Returns the `appFilters` value to be forwarded to `onSubmit`.
 *
 * Undefined (no filter) when Rovo controls are suppressed (see
 * `areRovoControlsSuppressed`): a mentioned specialist agent owns its sources,
 * or a specialist agent owns the turn.
 */
export const getAppFiltersForSubmit = ({
	isAgentMentionActive,
	isSpecialistPromptInput,
	appFilters,
}: AppFiltersForSubmitParams): RovoApp[] | undefined =>
	areRovoControlsSuppressed({ isAgentMentionActive, isSpecialistPromptInput })
		? undefined
		: appFilters;
